import React from 'react';
import { cn } from './lib/utils';

export function Label({ className, ...props }) {
  return (
    <div
      data-is-label
      className={cn(
        'flex min-h-[var(--button-height)] items-center justify-between text-[length:var(--secondary-font-size)] text-muted-foreground',
        className,
      )}
      {...props}
    />
  );
}
